/**
 * @generated SignedSource<<13d3e58976b33925fdc151ab3da7c25c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAIStagingRulePanel_ProductNameQuery$variables = {
  id: string;
};
export type addAIStagingRulePanel_ProductNameQuery$data = {
  readonly node: {
    readonly name?: string;
  } | null;
};
export type addAIStagingRulePanel_ProductNameQuery = {
  response: addAIStagingRulePanel_ProductNameQuery$data;
  variables: addAIStagingRulePanel_ProductNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addAIStagingRulePanel_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addAIStagingRulePanel_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4397c9ed8c16f6b444a11c49f7c2e585",
    "id": null,
    "metadata": {},
    "name": "addAIStagingRulePanel_ProductNameQuery",
    "operationKind": "query",
    "text": "query addAIStagingRulePanel_ProductNameQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "28cef08c12df6c5f2372617336e3bb48";

export default node;
